/**
 * YoY % is not meaningful with no prior baseline; avoid showing +0.0%.
 */
export function format_yoy_change_percent(
  prior: number,
  change_percent: number,
  format_fraction: (value: number) => string
): string {
  if (prior <= 0) {
    return '—';
  }
  return format_fraction(change_percent);
}
